import { useEffect, useState } from 'react';
import { useCurtainStore } from '../../stores/curtain.store';

// Rete di sicurezza: se animationend non arriva (overlay nascosto da CSS,
// tab in background) il sipario si smonta comunque poco dopo la sequenza
// prevista (luce 300 ms + apertura 620 ms).
const FALLBACK_MS = 1300;

/** Root del sipario di login. Montato una volta in App, fuori dalle route. */
export function LoginCurtainRoot() {
  const active = useCurtainStore((s) => s.active);
  if (!active) return null;
  return <LoginCurtain />;
}

/**
 * Replica statica della login (pannello ink 56% con logo e M in filigrana,
 * carta 44% vuota, linea di soglia). Sequenza unica, tutta in CSS: prima una
 * luce sottile scende lungo la soglia come un fendente (300 ms), poi i
 * pannelli scorrono ai lati e scoprono l'app già montata dietro (620 ms).
 * Nessun form, nessun input.
 */
function LoginCurtain() {
  const done = useCurtainStore((s) => s.done);
  // La carta prende il colore che la login aveva in QUESTO istante: AppShell,
  // montandosi dietro, può cambiare canvas (dark) e --surface cambierebbe
  // sotto i nostri piedi a metà scorrimento. Il pannello ink è theme-invariant.
  const [paper] = useState(() => getComputedStyle(document.body).getPropertyValue('--surface').trim() || undefined);

  useEffect(() => {
    const t = setTimeout(done, FALLBACK_MS);
    return () => clearTimeout(t);
  }, [done]);

  return (
    <div className="login-curtain" aria-hidden="true">
      {/* Il pannello ink riceve anche l'animationend della soglia (::after) a 300 ms:
          si smonta solo a fine apertura, cioè quando termina curtainLeft. */}
      <div className="login-curtain-brand" onAnimationEnd={(e) => { if (e.animationName === 'curtainLeft') done(); }}>
        <img src="/logos/masamune.svg" alt="" className="login-brand-logo" />
        <div className="login-brand-foot">
          <div className="login-payoff">Built for the people <span className="login-payoff-em">building the future</span>.</div>
          <div className="login-os">OS v0.1</div>
        </div>
      </div>
      <div className="login-curtain-paper" style={{ background: paper }} />
      {/* La luce che taglia la soglia prima che i pannelli si aprano */}
      <div className="login-curtain-blade" />
    </div>
  );
}
